// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.centered-module {
    display: flex;
    width: 471px;
    padding: 12px 18px 24px 18px;
    flex-direction: column;
    gap: 24px;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid var(--Borda, #E7E7E7);
    background-color: var(--background-surface, #FBFCFE);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/CenterModule/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,oDAAoD;IACpD,yCAAyC;AAC7C","sourcesContent":[".overlay {\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.centered-module {\n    display: flex;\n    width: 471px;\n    padding: 12px 18px 24px 18px;\n    flex-direction: column;\n    gap: 24px;\n    padding: 20px;\n    border-radius: 12px;\n    border: 1px solid var(--Borda, #E7E7E7);\n    background-color: var(--background-surface, #FBFCFE);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
